export { default } from './loyalty-rewards';
export { default as LoyaltyRewards } from './loyalty-rewards';
